import { Form, Input, Button, Row, Col } from "antd";

const ParkingBayFilters = ({ onFilter, filterType }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const filters = {
      stateName: values.stateName || null,
      districtName: values.districtName || null,
      parkingBayName: values.parkingBayName || null
    };
    onFilter(filters);
  };

  const handleReset = () => {
    form.resetFields();
    onFilter({});
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical" style={{ margin: "1rem"}} autoComplete="off">
      <Row gutter={16} style={{ alignItems: "center"}}>
        <Col span={6}>
          <Form.Item name="stateName" label="State Name">
            <Input placeholder="Enter State Name" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="districtName" label="District Name">
            <Input placeholder="Enter District Name" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="parkingBayName" label="Master Location Name">
            <Input placeholder="Enter Location Name" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Button type="primary" htmlType="submit">Apply Filters</Button>
          <Button onClick={handleReset} style={{ marginLeft: 8 }}>Reset</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ParkingBayFilters;
